import React from "react";
import DataTable from "../Pages/DataTabe";

const Table = () => {
  return (
    <section className='home'>
      <div className='container'>
        <div className='heading flexSB'>          
          <div className="flex items-center">            
          </div>
        </div>
        <DataTable />
      </div>
    </section>
  );
};

export default Table;
